module.exports = __webpack_public_path__ + "img/center_text4.2c511309.png";